export const BILLING_DETAILS_LOADED = 'BILLING_DETAILS_LOADED';
export const CLIENT_ACTIVITY_LOADED = 'CLIENT_ACTIVITY_LOADED';
export const INVOICES_LOADED = 'INVOICES_LOADED';
export const SUBSCRIPTION_CANCELLED = 'SUBSCRIPTION_CANCELLED';
export const SUBSCRIPTION_LOADED = 'SUBSCRIPTION_LOADED';
export const SUBSCRIPTION_TYPES_LOADED = 'SUBSCRIPTION_TYPES_LOADED';
